export const PATH = '/edition/screen';
